// extracted by mini-css-extract-plugin
export default {"snapContainer":"AutomatedProduction_snapContainer__9eTqU","snapSection":"AutomatedProduction_snapSection__2qqZg"};